var map = {
	"./Calculator.png": 586,
	"./Chess.png": 946,
	"./Countdown.png": 616,
	"./Cryptocurrency.png": 202,
	"./DrawingApp.png": 690,
	"./Music.png": 849,
	"./Portfolio.png": 939,
	"./QuizApp.png": 828,
	"./Snake.png": 691,
	"./Stopwatch.png": 651,
	"./Timer.png": 818,
	"./WeatherApp.png": 479
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 574;